module.exports = __webpack_public_path__ + "static/media/ic_store-gray.50a1fdbc.svg";